import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import { getActiveCertification } from 'src/utils/escrow';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { InvitationStatusEnum } from 'src/graphql/schema';
import { cn } from 'src/lib/utils';

import { Basics, ActivateProgressSteps, VerificationBadges, Activity, Certification } from './ui';

const SoftwareEscrowOverview = () => {
  const location = useLocation();
  const {
    softwareEscrow: { activatedAt, certificationVerified, certificationCertified, escrowInvitation },
  } = useSoftwareEscrow();
  const certificationRef = useRef<HTMLDivElement>(null);

  const activeCertification = getActiveCertification({
    activatedAt,
    certificationVerified,
    certificationCertified,
  });

  useLayoutEffect(() => {
    if (location.state?.scrollToCertificate && certificationRef?.current) {
      certificationRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Clean up the state so back/forward navigation doesn't re-trigger scroll
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div
      className={cn('container @container mx-auto space-y-6', {
        'opacity-70 pointer-events-none': escrowInvitation?.status === InvitationStatusEnum.Rejected,
      })}
    >
      <div className="grid grid-cols-12 gap-6 min-h-[300px]">
        {activeCertification ? (
          <VerificationBadges className="col-span-12 xl:col-span-5" ref={certificationRef} />
        ) : (
          <ActivateProgressSteps className="min-h-[300px] col-span-12 xl:col-span-5" />
        )}
        <Basics className="col-span-12 xl:col-span-7" />
      </div>
      <Activity />
      <Certification ref={certificationRef} />
    </div>
  );
};

export default SoftwareEscrowOverview;
